import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

import { ImagePreviewPreloader } from './components';

import styles from './ImagePreview.module.scss';


type TProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
	isLoading?: boolean;
};

export function ImagePreview(props: TProps) {
	const {
		isLoading,
		className = '',
		...restProps
	} = props;

	if (isLoading) {
		return (
			<ImagePreviewPreloader />
		);
	}

	const classNames = [styles.preview];

	if (className) {
		classNames.push(className);
	}

	return (
		<img title="Просмотреть изображение" { ...restProps } className={ classNames.join(' ') } />
	);
}
